import React from 'react'

import { LoadingPage } from '~/pages/LoadingPage'

export const LoadingAuthentication = () => <LoadingPage />
